module.exports = __webpack_public_path__ + "media/images/icons/check-bd530f4d9fdcba72e60c0fec9088e027.svg";